<template>
  <div>
    <div class="MENU w-100">
      <div class="container">
        <div class="d-flex w-100">
          <div class="p-y-3 m-r-auto d-flex">
            <div
                v-for="(link, mIndex) in Links"
                :key="mIndex"
                class="m-r-2:mo m-r-6:t m-l-1:mo m-l-2:t">
              <router-link
                  v-if="link.isRoute"
                  :to="{
                    name: link.name,
                  }"
                  class="ACCOUNT-LINK-LABEL m-l-auto:d"
                  :class="{ 'ACCOUNT-ACTIVE': link.name === $route.name }"
              >
                {{link.label}}
              </router-link>
              <div v-else>
                <span class="ACCOUNT-LINK-LABEL" @click="nonRouteClick(link)">
                  {{link.label}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="SUB-MENU-SPACER"></div>
  </div>
</template>

<script>

export default {
  name: 'pro-homepage-sub-menu',
  data () {
    return {
      Links: [
        {
          name: 'pro-homepage',
          label: 'Pro Home',
          isRoute: true,
        }, {
          name: 'Join as a Pro',
          label: 'Join as a Pro',
        }, {
          name: 'Help Center',
          label: 'Pro Help Center',
        },
      ],
    };
  },
  methods: {
    nonRouteClick (route) {
      if (route.label === 'Pro Help Center') {
        window.open(`${this.$runtimeConstants.SALESFORCE_HELP_CENTER}?login=true`, '_blank');
      }
      if (route.label === 'Join as a Pro') {
        const url = this.$route.query.source
          ? `${this.$runtimeConstants.SALESFORCE_BECOME_A_PRO}?source=${this.$route.query.source}`
          : this.$runtimeConstants.SALESFORCE_BECOME_A_PRO;
        if (this.$route.query.referredById) {
          window.open(`${url}&referredById=${this.$route.query.referredById}`, '_self');
        } else {
          window.open(url, '_self');
        }
      }
      if (route.label === 'Sign Out') {
        this.$store.dispatch('user/logout');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

$shadow: -2px 2px 3px rgba(0, 0, 0, 0.5);

.MENU {
  position: fixed;
  top:0;
  width: 100%;
  z-index: 20;
  box-shadow: $shadow;
  background-color: white;
  margin-top: 72px;
  @include mobile-only () {
    margin-top: 54px;
  }
  .ACCOUNT-LINK-LABEL {
        color: #000;
        font-size: 16px;
        font-weight: bold;
        text-transform: capitalize;
        cursor: pointer;
        @include mobile-only () {
          font-size: 14px;
        }
    }
}
.ACCOUNT-ACTIVE {
  padding-bottom: 10px;
    color: $color-depot !important;
    border-bottom: 2px solid $color-depot;
}
.SUB-MENU-SPACER {
  margin-top: 72px;
  @include mobile-only () {
    margin-top: 54px;
  }
}
</style>
